import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const FileVector = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25.25 14C26.762 14 28 12.762 28 11.25V6.75C28 5.237 26.762 4 25.25 4H20.75C19.238 4 18 5.237 18 6.75V8H14V6.75C14 5.237 12.762 4 11.25 4H6.75C5.237 4 4 5.237 4 6.75V11.25C4 12.762 5.237 14 6.75 14H8V18H6.75C5.237 18 4 19.238 4 20.75V25.25C4 26.762 5.237 28 6.75 28H11.25C12.762 28 14 26.762 14 25.25V24H18V25.25C18 26.762 19.238 28 20.75 28H25.25C26.762 28 28 26.762 28 25.25V20.75C28 19.238 26.762 18 25.25 18H24V14H25.25ZM20 6.75C20 6.338 20.337 6 20.75 6H25.25C25.663 6 26 6.338 26 6.75V11.25C26 11.662 25.663 12 25.25 12H20.75C20.337 12 20 11.662 20 11.25V6.75ZM6 11.25V6.75C6 6.338 6.338 6 6.75 6H11.25C11.662 6 12 6.338 12 6.75V11.25C12 11.662 11.662 12 11.25 12H6.75C6.338 12 6 11.662 6 11.25ZM12 25.25C12 25.663 11.662 26 11.25 26H6.75C6.338 26 6 25.663 6 25.25V20.75C6 20.337 6.338 20 6.75 20H11.25C11.662 20 12 20.337 12 20.75V25.25ZM26 20.75V25.25C26 25.663 25.663 26 25.25 26H20.75C20.337 26 20 25.663 20 25.25V20.75C20 20.337 20.337 20 20.75 20H25.25C25.663 20 26 20.337 26 20.75ZM22 18H20.75C19.238 18 18 19.238 18 20.75V22H14V20.75C14 19.238 12.762 18 11.25 18H10V14H11.25C12.762 14 14 12.762 14 11.25V10H18V11.25C18 12.762 19.238 14 20.75 14H22V18Z" />
	</svg>
);

export default FileVector;
